<div class="modal active report">
  <div class="modal__container">
    <div class="fields">
      <h2 class="title">Export Procedure Performance Report </h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form *ngIf="report != null" autocomplete="off"  name="ngReportForm" #ngForm="ngForm" id="ReportForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Export Options</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Author</label>
                  <input
                    maxlength="50"
                    type="text"
                    name="authorReport"
                    [(ngModel)]="report.author"
                    required
                  >
                </div>
                <div>
                  <label for="">Date</label>
                  <input type="date" (change)="setDate($event.target.value)" required>
                </div>
                <div>
                  <label for="">File Type</label>
                    <select id="reportFileType"  name="reportFileType" [(ngModel)]="report.fileType">
                      <option value="pdf">PDF</option>
                      <option value="rtf">RTF</option>
                    </select>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'"
              (click)="generateReport(); " [disabled]="!ngForm.form.valid">
              Save
            </button>
            <button class="gray" (click)="cancel()">Cancel</button>
          </div>
        </form>


      </div>
    </div>
  </div>
</div>
